/**
 * Construit une query string (`?a=1&b=2`) en ignorant les valeurs vides/nulles.
 * Renvoie '' si aucun paramètre exploitable.
 */
export function qs(params) {
  if (!params) return ''
  const sp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) sp.append(key, value)
  })
  const s = sp.toString()
  return s ? `?${s}` : ''
}
